import getFilesByIds from './helpers/getFilesByIds';
import getAllFiles from './helpers/getAllFiles';
import groupErrors from './helpers/groupErrors';

export const isUploadStarted = (state) => state.import.inProgress;

export const requiredFields = (state) => state.import.requiredFields;
export const selectedFieldsSelector = (state) => getFilesByIds(state.import.items, state.import.selected).map(({ fields }) => fields);
export const itemsErrorsSelector = (state) => groupErrors(getAllFiles(state.import.items));
